module.exports = __webpack_public_path__ + "static/img/airoad_card.95b58636.png";